type SectionHeadingProps = {
  eyebrow: string;
  heading: string;
  align?: 'left' | 'center';
};

export default function SectionHeading({ eyebrow, heading, align = 'left' }: SectionHeadingProps) {
  return (
    <div className={align === 'center' ? 'text-center' : 'text-left'}>
      <p className="text-sm font-semibold uppercase tracking-[0.2em] text-coral">{eyebrow}</p>
      <h2 className="mt-2 text-3xl font-display text-ink sm:text-4xl">{heading}</h2>
    </div>
  );
}
